module.exports = __webpack_public_path__ + "img/s-hd.b9619ae2.jpg";